<template>
  <div>
    <video-js ref="videoPlayer" class="video-js vjs-default-skin vjs-live vjs-liveui" preload="auto" data-setup='{"fluid": true, "liveui": true}' ></video-js>
  </div>
</template>

<script>
import videojs from "video.js";
import "@videojs/http-streaming/dist/videojs-http-streaming";
import "video.js/dist/video-js.css"

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("onPlayerReady", this);
      }
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
